module.exports = __webpack_public_path__ + "img/yishi15.05cab9b7.jpg";